<template>
  <v-container fluid class="pa-8">
    <h2 class="text-h4 font-weight-bold mb-6">
      New/Edit Patent Docket
    </h2>
    <!-- <v-card color="#FAFAFA"> -->
    <div class="pl-4 pr-4">
      <v-tabs v-model="tabselect" color="#55638E" class="custom-tabs" style="border-bottom: 1px solid #E0E0E0;">
        <v-tab>Internal Work</v-tab>
        <v-tab>Internal Timeline</v-tab>
      </v-tabs>
    </div>
    <div v-if="tabselect == 0" class="mt-4 pl-4 pr-4">



      <v-card class="pa-10">
        <v-row class="pt-3">
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Object Type</h3>
            <v-autocomplete v-model="itemdata.objecttype" :items="objecttype_list" item-text="objecttype_code"
              item-value="objecttype_id" outlined dense></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Work Type</h3>
            <v-autocomplete v-model="itemdata.doctype" :items="documenttype_ptlist_search" item-text="documenttype_code"
              item-value="documenttype_id" outlined dense @input="
                () => {
                  if (itemdata.refno == '' || itemdata.refno == null) {
                    $nextTick(() => {
                      itemdata.doctype = 0;
                    });
                    $store.state.global_dialog = true;
                    setupAlertDialog(
                      true,
                      'Check data',
                      'Put File NO',
                      'text-h5 red--text text-center'
                    );
                    return;
                  }
                  // calDateFinalDeadline();
                  checktypeFunction();
                }
              "></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>File No.</h3>
            <v-text-field class="widthsizesearch heightsizesearch" outlined dense
              v-on:keyup.enter="onSearchfile_no(itemdata.refno)" @blur="onSearchfile_no(itemdata.refno)"
              v-model="itemdata.refno"></v-text-field>
            <h4 class="red--text">* input text and enter for search</h4>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Application No.</h3>
            <v-text-field v-model="app_noshow" disabled background-color="#F5F5F5" outlined dense></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mth">
          <v-col cols="12" sm="3" md="3">
            <h3>Client Name</h3>
            <v-textarea v-model="itemdata.trademark_name" outlined dense disabled auto-grow rows="1"
              class="no-resize-textarea" background-color="#F5F5F5" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Agent Name</h3>
            <v-text-field v-model="agent_contact_name" outlined dense disabled
              background-color="#F5F5F5"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Associate Name</h3>
            <v-text-field v-model="associate_contact_name" outlined dense disabled
              background-color="#F5F5F5"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Doc Type</h3>
            <v-autocomplete v-model="doctype_actions_select" :items="doctype_actions_tlist" item-text="name"
              item-value="id" multiple chips outlined dense clearable />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-row align="start">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Notice File(s)</h3>
                <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                  @change="previewMultiFile" ref="noticefile" style="display: none" />
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                }" @click="$refs.noticefile.click()" class="widthbtnnoticefile" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload</v-btn>
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.filenamenotice.length > 0">
                  <v-row v-for="(item, index) in filenamenotice" :key="index" style="padding-left: 70px">
                    <span @click="previewnoticefilepdf(index)" class="file-link">
                      {{ item }}
                    </span>
                    <v-btn icon color="red" @click="confirmdeletenoticefile(index)" style="margin-top: -7px">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row align="start">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Submitted File(s)</h3>
                <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                  @change="previewMultiAttachFile" ref="attachfile" style="display: none" />
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                }" @click="$refs.attachfile.click()" class="widthbtnnoticefile" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload</v-btn>
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.image_listattach.length > 0">
                  <v-row v-for="(item, index) in this.image_listattach" :key="index" style="padding-left: 70px">
                    <span @click="previewattachfile(index)" class="file-link">
                      {{ item.name }}
                    </span>
                    <v-btn icon color="red" @click="confirmdeleteattachfile(index)" style="margin-top: -7px">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row align="start">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Receipt(s)</h3>
                <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                  @change="previewMultiReceipt" ref="receipt" style="display: none" />
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                }" @click="$refs.receipt.click()" class="widthbtnnoticefile" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload</v-btn>
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-10">
                <div v-if="this.image_listrecicpt.length > 0">
                  <v-row v-for="(item, index) in this.image_listrecicpt" :key="index" style="padding-left: 70px">
                    <span @click="previewreceiptfile(index)" class="file-link">
                      {{ item.name }}
                    </span>
                    <v-btn icon color="red" @click="confirmdeleteattreceipt(index)" style="margin-top: -7px">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-5" align="start">
              <v-col cols="4" sm="4" md="4">
                <h3>Upload Soft File(s)</h3>
                <v-btn :style="{
                  backgroundColor: '#254E58',
                  color: 'white',
                }" @click="openselectFileWorld()" class="widthbtnnoticefile" elevation="7">
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload</v-btn>
              </v-col>
              <v-col cols="8" sm="8" md="8" class="mt-8">
                <v-row v-for="(label, key) in checkboxFields" :key="key" v-if="checkboxes[key]">
                  <v-col cols="4" sm="4" md="4" style="padding-left: 70px">
                    <h4>{{ label }}</h4>
                  </v-col>

                  <v-col cols="8" sm="8" md="8" class="d-flex align-start">
                    <h4 style="padding-right: 11px">:</h4>

                    <input :ref="`fileInput_${key}`" type="file" multiple
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      style="display: none" @change="handleFileUpload($event, key)" />
                    <v-list dense class="mr-2">
                      <v-list-item v-for="(file, index) in uploadedFiles[key]" :key="index" class="px-0"
                        style="margin-top: -17px; margin-bottom: -20px">
                        <v-list-item-content>
                          <v-list-item-title style="color: #1d88ac; font-size: 14px">{{ file.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon color="red" small style="cursor: pointer" @click="removeFile(key, index)">
                            mdi-close
                          </v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>

                    <v-icon width="15px" class="bt-add" style="cursor: pointer" @click="triggerFileInput(key)">
                      mdi-plus
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <div v-if="showChage">
              <v-checkbox v-model="changeMasterRecord.type" label="Type"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.title" label="Title" style="margin-top: -20px"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.titleInThai" label="Title In Thai"
                style="margin-top: -20px"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.clientName" label="Client Name"
                style="margin-top: -20px"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.agentReference" label="Agent Reference"
                style="margin-top: -20px"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.agentName" label="Agent Name"
                style="margin-top: -20px"></v-checkbox>
              <v-checkbox v-model="changeMasterRecord.associateName" label="Associate Name"
                style="margin-top: -20px"></v-checkbox>
            </div>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="showNewFilingSubdoc">
          <v-col cols="12" sm="3" md="3" v-if="!showNewFilingSubdoc">
            <h3>Priority Deadline</h3>
            <v-menu v-model="menuaddnewfilling" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.new_filling" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="new_filling = parseDate(itemdata.new_filling)"
                  @blur="new_filling = parseDate(itemdata.new_filling)" append-icon="mdi-calendar" v-bind="attrs"
                  v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="new_filling" @input="menuaddnewfilling = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="showNewFilingExact">
            <h3>Internal Deadline</h3>
            <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.enddate" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="enddate = parseDate(itemdata.enddate)" @blur="enddate = parseDate(itemdata.enddate)"
                  append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="enddate" @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-else />
          <v-col cols="12" sm="6" md="6" />
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="showChage">
          <v-col cols="12" sm="3" md="3">
            <h3>Submit Date</h3>
            <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.filling_date" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                  filling_date = parseDate(itemdata.filling_date)
                  " @blur="filling_date = parseDate(itemdata.filling_date)" append-icon="mdi-calendar" v-bind="attrs"
                  v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="filling_date" @input="menuFilling = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="9" md="9" />
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="default_col">
          <v-col cols="12" sm="3" md="3">
            <h3 v-if="showSub">
              <span class="red--text">* </span>Publication Date
            </h3>
            <h3 v-else-if="showNewFilingSubdoc">
              <span class="red--text">* </span>Application Date
            </h3>
            <h3 v-else><span class="red--text">* </span>Receive Date</h3>
            <v-menu v-model="menuReceive" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.receive_date" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                  receive_date = parseDate(itemdata.receive_date)
                  " @blur="receive_date = parseDate(itemdata.receive_date)" append-icon="mdi-calendar" v-bind="attrs"
                  v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="receive_date" @input="
                () => {
                  menuReceive = false;
                  calDateFinalDeadline();
                }
              "></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Submit Date</h3>
            <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.filling_date" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                  filling_date = parseDate(itemdata.filling_date)
                  " @blur="filling_date = parseDate(itemdata.filling_date)" append-icon="mdi-calendar" v-bind="attrs"
                  v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="filling_date" @input="menuFilling = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <h3 v-if="showSub">
              <span class="red--text">* </span>Sub Exam Request Deadline Date
            </h3>
            <h3 v-else><span class="red--text">* </span>Final Deadline</h3>
            <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.enddate" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="enddate = parseDate(itemdata.enddate)" @blur="enddate = parseDate(itemdata.enddate)"
                  append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="enddate" @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="red--text">* </span>Fixed Internal Date</h3>
            <v-menu v-model="menuDeadline" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.internaldate" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                  internaldate = parseDate(itemdata.internaldate)
                  " @blur="internaldate = parseDate(itemdata.internaldate)" v-bind="attrs" v-on="on" outlined dense
                  disabled background-color="#F5F5F5"></v-text-field>
              </template>

              <v-date-picker v-model="internaldate" @input="menuDeadline = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3"></v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="showAnn">
          <v-col cols="12" sm="3" md="3">
            <h3>Last Annuity Payment</h3>
            <v-autocomplete v-model="itemdata.dead_last_annuity_paid" :items="latest_list" outlined dense
              @input="calDateAnn()"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Date Of The Last Annuity Payment</h3>
            <v-menu v-model="menuaddlapd" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.last_annuity_paid" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                    " @blur="
                      last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="last_annuity_paid" @input="menuaddlapd = false">
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <h3>Next Payment Due Date</h3>
            <v-menu v-model="menuaddnad" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.next_annuity_date" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    next_annuity_date = parseDate(itemdata.next_annuity_date)
                    " @blur="
                      next_annuity_date = parseDate(itemdata.next_annuity_date)
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="next_annuity_date" @input="
                () => {
                  menuaddnad = false;
                  updateFinalDueDateFromNextAnnuity();
                }
              ">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Final Due Date For Next Payment</h3>
            <v-menu v-model="menuaddnadfinalDatePayment" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.final_due_date_for_next_payment" persistent-hint
                  hint="Format DD/MM/YYYY" @keydown.enter="
                    final_due_date_for_next_payment = parseDate(
                      itemdata.final_due_date_for_next_payment
                    )
                    " @blur="
                      final_due_date_for_next_payment = parseDate(
                        itemdata.final_due_date_for_next_payment
                      )
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
              </template>

              <v-date-picker v-model="final_due_date_for_next_payment" @input="menuaddnadfinalDatePayment = false">
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="showNewFilingExact">
          <v-col cols="12" sm="3" md="3">
            <h3>Application Date</h3>
            <v-menu v-model="menuaddAppD" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_application = parseDate(
                      itemdata.date_of_application
                    )
                    " @blur="
                      date_of_application = parseDate(
                        itemdata.date_of_application
                      )
                      " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                        $nextTick(() => {
                          itemdata.date_of_application = null;
                        })
                        "></v-text-field>
              </template>
              <v-date-picker v-model="date_of_application" @input="menuaddAppD = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Application Number</h3>
            <v-text-field v-model="itemdata.app_no" outlined dense @blur="onAppNoBlur"></v-text-field>
          </v-col>
          <v-col cols="0" sm="6" md="6" />
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance" v-if="showNewFilingExact">
          <v-col cols="12" sm="3" md="3">
            <h3>Priority Deadline</h3>
            <v-menu v-model="menuaddnewfilling" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.new_filling" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="new_filling = parseDate(itemdata.new_filling)"
                  @blur="new_filling = parseDate(itemdata.new_filling)" append-icon="mdi-calendar" v-bind="attrs"
                  v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="new_filling" @input="menuaddnewfilling = false">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="showNewFilingExact">
            <h3>Internal Deadline</h3>
            <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="itemdata.enddate" persistent-hint hint="Format DD/MM/YYYY"
                  @keydown.enter="enddate = parseDate(itemdata.enddate)" @blur="enddate = parseDate(itemdata.enddate)"
                  append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
              </template>

              <v-date-picker v-model="enddate" @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-else />
          <v-col cols="12" sm="6" md="6" />
        </v-row>
        <v-row justify="space-around" v-if="default_type">
          <v-col cols="12" sm="3" md="3">
            <h3>Source Type</h3>
            <v-select v-model="itemdata.sourcetype" clearable :items="sourcetypelist" outlined dense></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Type</h3>
            <v-select v-model="typeshow" clearable :items="typelist" item-text="type_name" item-value="type_number"
              outlined dense disabled background-color="#F5F5F5"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Title</h3>
            <v-text-field v-model="titleshow" outlined dense disabled background-color="#F5F5F5"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col cols="12" sm="6" md="6">
            <h3>Description</h3>
            <v-textarea v-model="itemdata.description" outlined dense>
            </v-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Remark</h3>
            <v-textarea v-model="itemdata.remark" outlined dense> </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" md="2">
            <h3>Status</h3>
            <v-select v-model="itemdata.closed" :items="statuslist" item-text="descriptions" item-value="module_id"
              outlined dense @change="sendToStatus"></v-select>
          </v-col>
          <v-col cols="4" md="3">
            <h3>Reported / Invoiced</h3>
            <v-select v-model="itemdata.report" :items="reportlist" item-text="report_name" item-value="report_value"
              outlined dense></v-select>
          </v-col>
          <!-- <v-col cols="4" md="2" >
                <v-checkbox
                  v-model="itemdata.cert"
                  :label="`Pending`"
                  color="success"
                  hide-details
                ></v-checkbox>
                &nbsp;
              </v-col>
              <v-col cols="4"  md="2">
                <v-checkbox
                  v-model="itemdata.report"
                  :label="`Report`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="4" md="2">
                <v-checkbox
                  v-model="itemdata.done"
                  :label="`Complete`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="4" md="2">
                <v-checkbox
                  v-model="itemdata.closed"
                  :label="`Close`"
                  color="success"
                  hide-details
                  disabled
                ></v-checkbox>
              </v-col> -->
        </v-row>
      </v-card>
    </div>
    <v-card-text v-if="tabselect == 1">
      <TimeLineOperations :showaddItem="itemdata" :statuslist="statuslist" :reportlist="reportlist"
        :modeOperations="modeOperations" :timelineStatus="timelineStatus" :status_note="status_note"
        :visible_check="visible_check" :showReportInv="true" :module_name="module_name"
        :timeline_case_id="timeline_case_id" @timelineStatus="timelineStatus = $event"
        @requestStatus="handleRequestStatus" @update:status_note="status_note = $event"
        @update:visible_check="visible_check = $event" />
    </v-card-text>
    <br />
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn
          @click="$router.back()"
          depressed
          outlined
          width="100"
          color="red"
        >
          Delete
        </v-btn> -->
      <v-btn depressed class="mr-3 buttongold" @click="saveItem('paymentrequest')">
        Payment Request
      </v-btn>
      <v-btn @click="saveItem('save')" width="100" class="mr-3 ml-3 buttonblue" color="#112D32">
        Save
      </v-btn>
      <v-btn @click="$router.back()" depressed outlined width="100">
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <br />
    </v-card-actions>


    <v-dialog v-model="dialogpreviewfilenotice" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title>

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div v-if="checkfileapreview" v-for="(item, index) in previewpopupfile2" :key="index">
          <pdf :src="item" v-for="i in numPagespreview" :key="i" :id="i" :page="i">
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title>

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div v-if="checkattachfileapreview" v-for="(item, index) in previewpopupattachfile2" :key="index">
          <pdf :src="item" v-for="i in numPagespreviewattach" :key="i" :id="i" :page="i">
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachfile">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title>

        <v-img disabled :src="previewattachimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachimage">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closedialogconfirmdeletenoticefile">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeletenoticefile">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closedialogconfirmdeleteattachfile">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeleteattachfile">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogconfirmdeleteattrecipt" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewreceipt">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeletereceipt">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCheckbox" max-width="250px" persistent>
      <v-card class="pr-6 pl-6">
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-checkbox v-model="checkboxes.Form001" label="Form 001ก"></v-checkbox>
          <v-checkbox style="margin-top: -10px" v-model="checkboxes.Descriptions" label="Descriptions"></v-checkbox>
          <v-checkbox style="margin-top: -10px" v-model="checkboxes.Claims" label="Claims"></v-checkbox>
          <v-checkbox style="margin-top: -10px" v-model="checkboxes.Drawings" label="Drawings"></v-checkbox>
          <v-checkbox style="margin-top: -10px" v-model="checkboxes.Abstract" label="Abstract"></v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="cancelCheckbox">Cancel</v-btn>
          <v-btn color="primary" text @click="saveSelection">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card class="pa-10" style="border: 5px solid #e5e7eb;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="text-h4 font-weight-bold">Timeline Update Required</span>
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center" class="text-center">
            <span class="black--text text-body-1">
              Before saving this case, please update the internal timeline so the team can see the latest work status.
            </span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn depressed width="170" class="mr-3 " color="#0A7EA5" @click="deleteItemConfirm"
            style="border-radius: 20px; color: white; text-transform: none;">
            Update Timeline
          </v-btn>
          <v-btn depressed width="170" @click="closeDelete" color="red"
            style="border-radius: 20px; color: white; text-transform: none;">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <!-- <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card> -->
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    <SuccessDialogPushpaymentIM :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
      :link="link" :querydata="querydata" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import pdfvuer from "pdfvuer";
import TimeLineOperations from "../../timeline/TimeLineOperations.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";

export default {
  name: "AppoinmrntPatentOperation",

  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    TimeLineOperations,
    pdf: pdfvuer,
  },
  data() {
    return {

      tabselect: 0,
      timelineStatus: 0,
      status_note: "",
      visible_check: false,
      dialogDelete: false,
      timeline_case_id: 0,
      modeOperations: "New",
      module_name: "Patent Docket",

      menuaddAppD: false,
      uploadedFiles: {},
      uploadedFilesDoctype: {},
      dialogCheckbox: false,
      checkboxes: {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      },
      checkboxFields: {
        Form001: "Form 001ก",
        Descriptions: "Descriptions",
        Claims: "Claims",
        Drawings: "Drawings",
        Abstract: "Abstract",
      },
      changeMasterRecord: {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      },
      querydata: {},
      dataappiontment: {},
      isShowPassword: false,
      fullPage: true,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      objecttype_list: [],
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuaddlapd: false,
      menuDeadline: false,
      sourcetypelist: ["Electronic Notice", "Physical Paper Notice", "EMail"],
      statuslist: [
        // { status_name: "Pending", status_value: 1 },
        // { status_name: "Completed", status_value: 2 },
        // { status_name: "Close", status_value: 3 },
      ],
      reportlist: [
        { report_name: "Not Reported", report_value: 0 },
        { report_name: "Reported", report_value: 4 },
        { report_name: "Reported – Pending Invoice", report_value: 1 },
        { report_name: "Invoiced", report_value: 2 },
        { report_name: "Reported & Invoiced", report_value: 3 },
      ],
      category_ptlist: [
        "New Application",
        "Office Action",
        "Publication Fee",
        "Publication",
        "Substantive Examination",
        "Publication Fee & Registration Fee",
        "Publication Fee & Registration Fee & Annuity Fee",
        "Registration Fee",
        "Registration Fee & Annuity Fee",
        "Certificate",
        "Annuity Fee",
      ],
      doctype_actions_select: [],
      doctype_actions_tlist: [],
      typelist: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention/PCT", type_number: "4" },
      ],
      documenttype_ptlist: [],
      documenttype_ptlist_search: [],
      app_noshow: "",
      typeshow: 0,
      titleshow: "",
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      filling_date: null,
      startdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      enddate: null,
      internaldate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      associate_contact_name: "",
      agent_contact_name: "",
      date_of_application: null,
      itemdata: {
        new_filling: null,
        date_of_application: null,
        last_annuity_paid: null,
        owner_contact: "",
        associate_contact: 0,
        agent_contact: 0,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        dead_last_annuity_paid: "",
        objecttype: 0,
        doctype: 0,
        trademark_name: "",
        refno: "",
        categories: "",
        filling_date: null,
        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        startdate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        enddate: null,
        internaldate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        sourcetype: "",
        app_no: "",
        description: "",
        remark: "",
        report: 0,
        paymentrequest: false,
        cert: false,
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        done: false,
        closed: 1,
      },
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      preview_listrecicpt: [],
      image_listattach: [],
      image_listrecicpt: [],
      filenameattach: [],
      filenamerecive: [],
      getpreview_listattach: [],
      getpreview_listreceipt: [],
      preview_listattach2: [],
      preview_listrecipt2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      dialogconfirmdeleteattrecipt: false,
      indexdeleteattachfile: -1,
      indexdeleteattreciept: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest: 0,
      showAnn: false,
      showAnnReg: false,
      showAnnfirst: false,
      showNew: false,
      showChage: false,
      showSub: false,
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuaddnewfilling: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      new_filling: false,
      data_maserter_pt: [],
      data_maserter_pt_priority: [],
      default_col: true,
      default_type: true,
      last_annuity_paid: null,
      next_annuity_date: null,
      final_due_date_for_next_payment: null,
      contact_agent_list: [],
      contact_associate_list: [],
      contact_owner_list: [],
      showNewFilingExact: false,
      showNewFilingSubdoc: false,
    };
  },
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    await this.loadStatusList();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumentPTtype();

    // let map_data = await api.mapKeyWordPT(this.app_noshow, this.itemdata.refno);
    // this.itemdata.doctype = map_data.data.doctype_id;

    if (this.app_noshow !== "" && this.itemdata.refno !== "") {
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.app_noshow,
        this.itemdata.refno
      );

      if (ocr_data.data !== null) {
        let map_data = await api.mapKeyWordPT(
          this.app_noshow,
          this.itemdata.refno
        );
        this.itemdata.doctype = map_data.data.doctype_id;
      } else {
      }

      // --------------- check data in map table ----------------
    }
    await this.loadDataDotypeAction();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatafile_no();

    this.prev_doctype_actions_select = [...this.doctype_actions_select];
    this.$hideLoader();
  },
  methods: {
    //timeline functions
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },

    handleRequestStatus(value) {
      this.itemdata.closed = Number(value)
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        item => item.module_id === value
      )
      this.timelineStatus = Number(selectedItem.timeline_status_id)
    },
    async loadStatusList() {
      const result = await api.getClientTimelineStatusCongFigByModule("Patent Docket");

      this.statuslist = (result.data || []).map(item => ({
        ...item,
        module_id: Number(item.module_id)
      }));

      const selectedItem = this.statuslist.find(
        item => Number(item.module_id) === Number(this.itemdata.closed)
      )
      this.timelineStatus = Number(selectedItem.timeline_status_id)

    },
    //end time line functions
    async onAppNoBlur() {
      var check_appno = await api.getAppNpCheck({
        params: {
          id: this.data_maserter_pt.masterpt_id,
          app_no: this.itemdata.app_no,
        },
      });
      if (check_appno.status == 203) {
        this.itemdata.app_no = this.data_maserter_pt.app_no;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check Application No.",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      if (this.showAnnfirst) {
        date.setDate(date.getDate() + 59); // บวก 60 วัน
      } else {
        date.setDate(date.getDate() + 60);
      }

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    chageobjecttype() {
      if (this.itemdata.objecttype != 0) {
        const matchedDoc = this.documenttype_ptlist.filter(
          (item) => item.objecttype_id == this.itemdata.objecttype
        );

        this.documenttype_ptlist_search = matchedDoc;
        const exists = this.documenttype_ptlist_search.some(
          (item) => item.documenttype_id === this.itemdata.doctype
        );
        if (!exists) {
          this.itemdata.doctype = 0;
        }
      }
    },
    calDateAnn() {
      this.itemdata.next_annuity_date = this.formatDate(
        this.data_maserter_pt.next_annuity_date_pt
      );

      const cal_y =
        Number(this.itemdata.dead_last_annuity_paid) -
        Number(this.data_maserter_pt.dead_last_annuity_paid_pt);

      if (cal_y !== 0) {
        // แปลง next_annuity_date จาก dd/mm/yyyy → Date
        const [day, month, year] = this.itemdata.next_annuity_date
          .split("/")
          .map(Number);
        const nextDate = new Date(year, month - 1, day);

        // เพิ่ม/ลดปีตาม cal_y
        nextDate.setFullYear(nextDate.getFullYear() + cal_y);

        // กำหนดค่ากลับให้ next_annuity_date
        const updatedNextDate = `${nextDate.getFullYear()}-${String(
          nextDate.getMonth() + 1
        ).padStart(2, "0")}-${String(nextDate.getDate()).padStart(2, "0")}`;
        this.itemdata.next_annuity_date = this.formatDate(updatedNextDate);

        // คำนวณ final_due_date โดยบวก 60 วัน
        const finalDue = new Date(nextDate);

        if (this.showAnnfirst) {
          finalDue.setDate(finalDue.getDate() + 59);
        } else {
          finalDue.setDate(finalDue.getDate() + 60);
        }

        const d = String(finalDue.getDate()).padStart(2, "0");
        const m = String(finalDue.getMonth() + 1).padStart(2, "0");
        const y = finalDue.getFullYear();

        this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
      } else {
        // ไม่ต้องคำนวณใหม่ ใช้ค่าจาก master
        this.itemdata.next_annuity_date = this.formatDate(
          this.data_maserter_pt.next_annuity_date_pt
        );
        this.itemdata.final_due_date_for_next_payment = this.formatDate(
          this.data_maserter_pt.final_due_date_for_next_payment_pt
        );
      }

      this.$forceUpdate();
    },
    fileDoctypeInput() {
      // หาว่า id ไหนถูกลบออก
      const removed = this.prev_doctype_actions_select.filter(
        (id) => !this.doctype_actions_select.includes(id)
      );

      // ลบไฟล์ที่เกี่ยวข้อง
      removed.forEach((id) => {
        this.$delete(this.uploadedFilesDoctype, id);
      });

      // อัปเดตค่าก่อนหน้า
      this.prev_doctype_actions_select = [...this.doctype_actions_select];
    },
    async loadDataDotypeAction() {
      const res_doctye_actions = await api.getbyobjectgroup_id(2);
      this.doctype_actions_tlist = res_doctye_actions.data;
    },
    triggerFileInput(key) {
      this.$refs[`fileInput_${key}`][0].click();
    },
    handleFileUpload(event, key) {
      const files = Array.from(event.target.files);

      // เก็บชื่อไฟล์ทั้งหมดที่มีอยู่ใน uploadedFiles ทุก key
      const allUploadedNames = Object.values(this.uploadedFiles)
        .flat()
        .map((f) => f.name);

      if (!this.uploadedFiles[key]) {
        this.$set(this.uploadedFiles, key, []);
      }

      files.forEach((file) => {
        let newName = file.name;
        let baseName = newName;
        let ext = "";

        // แยกนามสกุลไฟล์ (.docx, .doc ฯลฯ)
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          baseName = newName.substring(0, dotIndex);
          ext = newName.substring(dotIndex);
        }

        let counter = 1;
        // ตรวจสอบว่าชื่อไฟล์ซ้ำไหมใน allUploadedNames
        while (allUploadedNames.includes(newName)) {
          newName = `${baseName}-${counter}${ext}`;
          counter++;
        }

        // สร้างไฟล์ใหม่ clone พร้อมชื่อใหม่
        const renamedFile = new File([file], newName, { type: file.type });

        // เพิ่มชื่อใหม่เข้า allUploadedNames เพื่อกันชื่อซ้ำกับไฟล์ถัดไป
        allUploadedNames.push(newName);

        // เพิ่มไฟล์ลงใน uploadedFiles
        this.uploadedFiles[key].push(renamedFile);
      });
    },
    removeFile(key, index) {
      this.uploadedFiles[key].splice(index, 1); // ลบไฟล์ตาม index
    },
    triggerFileInputDoctype(itemId) {
      this.$refs[`fileInput_${itemId}`][0].click();
    },
    handleFileUploadDoctype(event, itemId) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.uploadedFilesDoctype, itemId, file);
      }
    },
    cancelCheckbox() {
      this.dialogCheckbox = false;
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.uploadedFiles = {};
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
    },
    saveSelection() {
      this.dialogCheckbox = false;
    },
    openselectFileWorld() {
      this.dialogCheckbox = true;
    },
    async previewMultiFile(event) {
      this.getpreview_listnotice = [];
      this.preview_listnotice = [];
      var getdataname = [];
      // this.image_listnotice = [];
      // this.filenamenotice = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listnotice.push(e.target.result);
            this.preview_listnotice.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listnotice.push(input.files[index]);
            getdataname.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // await this.getPdf(this.getpreview_listnotice, "newfile");
      this.preview_listnotice2 = this.preview_listnotice;
      getdataname.forEach((x) => {
        this.filenamenotice.push(x.name);
      });
      this.checkfilenotice = true;
    },
    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type == `application/pdf`) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${checkfile}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result; // Base64 image data
          let image_newTab = window.open(""); // เปิดแท็บใหม่
          image_newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin: 50px 0 0 0;
                    height: 80%;
                    overflow: hidden;
                    background-color: black;
                    display: flex;
                    justify-content: center; /* จัดกลางในแนวนอน */
                    align-items: center; /* จัดกลางในแนวตั้ง */
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                  }
                </style>
              </head>
              <body>
                <img src="${checkfile}" title="Image Preview" />
              </body>
            </html>
          `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async previewMultiAttachFile() {
      // this.preview_listattach = [];
      // this.image_listattach = [];
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // await this.getPdf(this.getpreview_listattach, "newfile");
      this.preview_listattach2 = this.preview_listattach;
      this.image_listattach.forEach((x) => {
        this.filenameattach.push(x.name);
      });
      this.checkfileattach = true;
    },
    async previewMultiReceipt() {
      // this.preview_listattach = [];
      // this.image_listattach = [];
      this.filenamerecive = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listreceipt.push(e.target.result);
            this.preview_listrecicpt.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listrecicpt.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      // await this.getPdf(this.getpreview_listattach, "newfile");
      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.image_listrecicpt.forEach((x) => {
        this.filenamerecive.push(x.name);
      });
      this.checkfileattach = true;
    },
    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listattach[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async previewreceiptfile(index) {
      if (this.filenamerecive[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listreceipt[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewreceipt = this.getpreview_listreceipt[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewreceipt}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    async loaddatafile_no() {
      if (this.$route.params.file_no) {
        this.itemdata.refno = this.$route.params.file_no;
        this.onSearchfile_no(this.itemdata.refno);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatadocumentPTtype() {
      const result = await api.getdocumenttype_ptcode();
      this.documenttype_ptlist = result.data;
      this.documenttype_ptlist_search = result.data;
    },
    async onSearchfile_no(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      this.$showLoader()
      this.itemdata.refno = this.itemdata.refno.trim().toUpperCase();
      const result = await api.getfile_noPT(file_no);
      console.log(result.data)
      if (result.data[0]) {
        this.data_maserter_pt = result.data[0];

        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id)
        );
        this.data_maserter_pt_priority = res_priority.data;

        this.titleshow = result.data[0].title;
        this.itemdata.objecttype = result.data[0].tm_type;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        // this.customer_id_forpatmentrequest =
        //   result.data[0].agent_contact_custid != 0
        //     ? result.data[0].agent_contact_custid
        //     : result.data[0].owner_contact_custid != 0
        //     ? result.data[0].owner_contact_custid
        //     : 0;

        // if (
        //   result.data[0].owner_contact_id &&
        //   result.data[0].owner_contact_id != ""
        // ) {
        //   this.itemdata.owner_contact = result.data[0].owner_contact_id;
        //   var ownername = result.data[0].owner_contact_id;
        //   var listid_owner = ownername.split(",").map((s) => Number(s.trim()));
        //   const matchedContactsOwner = this.contact_owner_list.filter(
        //     (contact) => listid_owner.includes(contact.contact_id)
        //   );
        //   this.itemdata.trademark_name = "";
        //   this.itemdata.trademark_name = matchedContactsOwner
        //     .map((c) => c.contact_name)
        //     .join(", ");
        // } else {
        //   this.itemdata.trademark_name = "";
        // }
        if (
          result.data[0].agent_contact_id &&
          result.data[0].agent_contact_id != 0
        ) {
          this.itemdata.agent_contact = result.data[0].agent_contact_id;

          this.contact_agent_list.filter((item) => {
            if (Number(item.contact_id) == Number(this.itemdata.agent_contact)) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
        }

        if (
          result.data[0].associate_contact_id &&
          result.data[0].associate_contact_id != 0
        ) {
          this.itemdata.associate_contact = result.data[0].associate_contact_id;
          this.contact_associate_list.filter((item) => {
            if (Number(item.contact_id) == Number(this.itemdata.associate_contact)) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
        }
        //   // else{
        //   //   this.agent_contact_name = ""
        //   // }
        this.$hideLoader()
        this.checktypeFunction();
      } else {
        this.$hideLoader()
        this.data_maserter_pt = [];
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        // this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async onSearchfile_nosave(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);

      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        // this.customer_id_forpatmentrequest =
        //   result.data[0].agent_contact_custid != 0
        //     ? result.data[0].agent_contact_custid
        //     : result.data[0].owner_contact_custid != 0
        //       ? result.data[0].owner_contact_custid
        //       : 0;
      } else {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        // this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    checktypeFunction() {
      if (this.itemdata.doctype == 0) return;

      const doctype = this.documenttype_ptlist.find(
        (item) => item.documenttype_id === this.itemdata.doctype
      );
      if (!doctype) return;

      const code = doctype.documenttype_code;

      const isAnnuity = code.includes("Annuity Fees");
      const isRegistration = code === "Registration & Annuity Fees";

      const isNewFiling = code.includes("New Filing");
      const isNewFilingExact = code === "New Filing";
      const isNewFilingSubDoc = code === "New Filing Sub Doc";

      const isChangeMaster = code.includes("Change Master of Record");
      const isSubstantiveExam = code.includes("Substantive Examination");

      // Default: reset flags
      this.default_col = !isAnnuity && !isNewFiling && !isChangeMaster;
      this.showAnn = false;
      this.showAnnReg = false;
      this.showAnnfirst = false;
      this.showNew = false;
      this.showNewFilingExact = false;
      this.showNewFilingSubdoc = false;
      this.showChage = false;
      this.showSub = false;

      // Clear fields
      this.itemdata.dead_last_annuity_paid = "";
      this.itemdata.last_annuity_paid = null;
      this.itemdata.next_annuity_date = null;
      this.itemdata.new_filling = null;
      this.itemdata.date_of_application = null;
      this.itemdata.receive_date = this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      );
      this.receive_date = this.changeformatDatetoinsert(
        this.itemdata.receive_date
      );

      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };

      if (isAnnuity) {
        this.default_col = false;
        this.showAnn = true;
        if (this.data_maserter_pt) {
          this.itemdata.dead_last_annuity_paid =
            this.data_maserter_pt.dead_last_annuity_paid_pt;
          this.itemdata.last_annuity_paid = this.formatDate(
            this.data_maserter_pt.last_annuity_paid_pt
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.data_maserter_pt.next_annuity_date_pt
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.data_maserter_pt.final_due_date_for_next_payment_pt
          );
        }
        if (isRegistration) {
          this.showAnnReg = true;
          this.default_col = true;
        } else {
          this.showAnnfirst = true;
        }
      }

      if (isNewFiling) {
        this.itemdata.enddate = null;
        this.showNew = true;
        this.default_col = false;

        const sorted = [...this.data_maserter_pt_priority].sort(
          (a, b) => new Date(a.priority_date) - new Date(b.priority_date)
        );
        const oldest = sorted[0]?.priority_date;
        if (oldest !== undefined && oldest) {
          const [y, m, d] = oldest.split("-").map(Number);
          const date = new Date(y, m - 1, d);

          if (this.data_maserter_pt.sub_type === "PARIS")
            date.setMonth(date.getMonth() + 12);
          if (this.data_maserter_pt.sub_type === "PCT")
            date.setMonth(date.getMonth() + 30);

          this.itemdata.new_filling = `${String(date.getDate()).padStart(
            2,
            "0"
          )}/${String(date.getMonth() + 1).padStart(
            2,
            "0"
          )}/${date.getFullYear()}`;
        }
        if (isNewFilingExact) {
          this.showNewFilingExact = true;
          this.itemdata.date_of_application = this.formatDate(
            this.data_maserter_pt.date_of_application
          );
          this.itemdata.app_no = this.data_maserter_pt.app_no;
          this.date_of_application = this.data_maserter_pt.date_of_application;
        } else if (isNewFilingSubDoc) {
          this.showNewFilingSubdoc = true;
          this.default_col = true;
          if (this.data_maserter_pt.date_of_application) {
            this.itemdata.receive_date = this.formatDate(
              this.data_maserter_pt.date_of_application
            );
            this.receive_date = this.changeformatDatetoinsert(
              this.itemdata.receive_date
            );
            this.calDateFinalDeadline();
          } else {
            this.itemdata.receive_date = null;
          }
        }
      }

      if (isChangeMaster) {
        this.showChage = true;
        this.default_col = false;
        this.default_type = false; // ✅ ตั้งค่า default_type ที่นี่เท่านั้น
      } else {
        this.default_type = true; // ✅ ถ้าไม่ใช่ Change Master ให้เป็น true
      }

      // No need to do anything for isSubstantiveExam – fields already cleared
      if (isSubstantiveExam) {
        this.showSub = true;
        if (this.data_maserter_pt.date_of_application) {
          this.itemdata.receive_date = this.formatDate(
            this.data_maserter_pt.date_of_publishing
          );
          this.receive_date = this.data_maserter_pt.date_of_publishing;

          this.itemdata.enddate = this.formatDate(
            this.data_maserter_pt.exam_request_deadline
          );
          this.enddate = this.data_maserter_pt.exam_request_deadline;

          this.enddate = this.data_maserter_pt.exam_request_deadline;

          if (this.enddate) {
            let d = new Date(this.enddate); // แปลง string → Date
            d.setDate(d.getDate() + 60); // บวก 60 วัน
            this.itemdata.internaldate = this.formatDate(
              d.toISOString().split("T")[0]
            ); // คืนค่าเป็น YYYY-MM-DD
            this.internaldate = d.toISOString().split("T")[0]; // คืนค่าเป็น YYYY-MM-DD
          } else {
            this.itemdata.internaldate = null;
          }

          // this.calDateFinalDeadline()
        } else {
          this.itemdata.receive_date = null;
        }
        // this.itemdata.receive_date = null;
        // this.itemdata.enddate = null;
        // this.itemdata.internaldate = null;
      } else {
        if (!isNewFiling && !isSubstantiveExam) {
          this.itemdata.receive_date = this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
          );
          this.calDateFinalDeadline();
        }
      }
      this.$forceUpdate();
    },
    calDateFinalDeadline() {
      if (this.itemdata.doctype != 0 && this.itemdata.doctype) {
        console.log(this.itemdata.receive_date);
        console.log(this.receive_date);
        if (this.showSub) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setFullYear(date.getFullYear() + 5);
          date.setDate(date.getDate() - 1);

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${d}/${m}/${y}`;

          const internalDate = new Date(date);
          const originalDay = internalDate.getDate();
          internalDate.setMonth(internalDate.getMonth() - 6);
          if (internalDate.getDate() < originalDay) {
            internalDate.setDate(0);
          }

          const iy = internalDate.getFullYear();
          const im = String(internalDate.getMonth() + 1).padStart(2, "0");
          const id = String(internalDate.getDate()).padStart(2, "0");
          this.itemdata.internaldate = `${id}/${im}/${iy}`;
        } else {
          const dataItem = this.documenttype_ptlist.find(
            (item) => item.documenttype_id === this.itemdata.doctype
          );

          const dateplus = dataItem?.numberofenddate
            ? dataItem.numberofenddate - 1
            : 0;

          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setDate(date.getDate() + dateplus);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${dd}/${mm}/${yyyy}`;

          const internalDate = new Date(date);
          internalDate.setDate(internalDate.getDate() - 7);

          const idd = String(internalDate.getDate()).padStart(2, "0");
          const imm = String(internalDate.getMonth() + 1).padStart(2, "0");
          const iyyyy = internalDate.getFullYear();
          this.itemdata.internaldate = `${idd}/${imm}/${iyyyy}`;
        }
      }
    },

    async saveItem(mode) {
      var dataset = [];
      // this.onSearchfile_nosave(this.itemdata.refno);

      if (this.itemdata.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.refno == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File NO ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (mode == "paymentrequest") {
        const checkMaterPT = await api.getfile_noPTPayment(this.itemdata.refno);
        console.log(checkMaterPT.data)
        if (checkMaterPT.data.length > 0) {
          dataset = checkMaterPT.data[0];

          if (!dataset.cus_billing_id || dataset.cus_billing_id == "") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data ",
              "Please verify the customer's billing details.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
      }
      // if (this.doctype_actions_select.length == 0) {
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Check data ",
      //     "Put Doc Type",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }

      if (this.showSub) {
        if (!this.itemdata.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Sub Exam Request Deadline Date",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (!this.itemdata.enddate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Fixed Internal Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.itemdata.internaldate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check data ",
            "Put Publication Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      const checkfile_noPT = await api.getfile_noPT(this.itemdata.refno);

      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }

      if (checkfile_noPT.data[0]) {
        let formData = new FormData();

        //Upload Notice File
        if (this.image_listnotice.length > 0) {
          this.image_listnotice.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }

        if (this.image_listnotice.length > 0) {
          let getnamefilenameattach = "";
          this.filenamenotice.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `notice_file`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }

        //Upload Submitted File(s
        if (this.image_listattach.length > 0) {
          this.image_listattach.forEach((x, index) => {
            formData.append(`file`, x);
          });
        }

        if (this.image_listattach.length > 0) {
          let getnamefilenameattach = "";
          this.filenameattach.forEach((x, index) => {
            if (index > 0) {
              getnamefilenameattach += `,${x}`;
            } else {
              getnamefilenameattach += `${x}`;
            }
          });
          formData.append(
            `attachment_files`,
            getnamefilenameattach.replace(/\s/g, "_")
          );
        }

        //Upload Receipt(s)
        if (this.image_listrecicpt && this.image_listrecicpt.length > 0) {

          this.image_listrecicpt.forEach((file) => {
            formData.append("file", file);
          });

          const safeFileNames = this.image_listrecicpt.map((file) => {
            return file.name
              .trim()
              .replace(/\s+/g, "_")
              .replace(/,+/g, "")
              .replace(/[^\w.-]/g, "");
          });

          const fileNameString = safeFileNames.join(",");

          formData.append("receipt_files", fileNameString);
        }

        // Upload Soft File(s)
        // if (
        //   this.uploadedFiles &&
        //   typeof this.uploadedFiles === 'object' &&
        //   Object.keys(this.uploadedFiles).length > 0
        // ) {
        //   for (const [key, value] of Object.entries(this.uploadedFiles)) {
        //     formData.append(`file`, value);
        //     formData.append(`${key}`, value.name);
        //   }

        // }

        formData.append("objecttype", this.itemdata.objecttype);
        formData.append("doctype", this.itemdata.doctype);

        formData.append("cert", this.itemdata.cert);
        formData.append("report", this.itemdata.report);
        formData.append("done", this.itemdata.done);
        formData.append("closed", this.itemdata.closed);

        formData.append("nextdeadlineninety", 0);
        formData.append("nextdeadlinesixty", 0);
        if (mode == "paymentrequest") {
          this.itemdata.paymentrequest = 1;
        }
        formData.append("paymentrequest", this.itemdata.paymentrequest);

        formData.append("sourcetype", this.itemdata.sourcetype);
        formData.append("trademark_name", ``);
        formData.append("owner_name", this.itemdata.trademark_name);
        formData.append(`refno`, this.itemdata.refno.trim());
        formData.append(`categories`, this.itemdata.categories.trim());
        formData.append(`description`, this.itemdata.description.trim());
        formData.append(`remark`, this.itemdata.remark);

        formData.append(
          `create_by`,
          Number(localStorage.getItem(server.USER_ID))
        );

        formData.append(`owner_contact`, this.itemdata.owner_contact);
        formData.append(`agent_contact`, this.itemdata.agent_contact);
        formData.append(`associate_contact`, this.itemdata.associate_contact);

        formData.append(
          `filling_date`,
          this.changeformatDatetoinsert(this.itemdata.filling_date)
        );
        formData.append(
          `receive_date`,
          this.changeformatDatetoinsert(this.itemdata.receive_date)
        );
        formData.append(
          `startdate`,
          this.changeformatDatetoinsert(this.itemdata.startdate)
        );
        formData.append(
          `enddate`,
          this.changeformatDatetoinsert(this.itemdata.enddate)
        );
        formData.append(
          `internaldate`,
          this.changeformatDatetoinsert(this.itemdata.internaldate)
        );
        if (this.showSub) {
          formData.append("check_sub", true);
        } else {
          formData.append("check_sub", false);
        }
        if (this.showAnn) {
          formData.append(
            "dead_last_annuity_paid",
            this.itemdata.dead_last_annuity_paid || ""
          );
          formData.append(
            "last_annuity_paid",
            this.changeformatDatetoinsert(this.itemdata.last_annuity_paid) || ""
          );
          formData.append(
            "next_annuity_date",
            this.changeformatDatetoinsert(this.itemdata.next_annuity_date) || ""
          );
          formData.append(
            "final_due_date_for_next_payment",
            this.changeformatDatetoinsert(
              this.itemdata.final_due_date_for_next_payment
            ) || ""
          );
          formData.append("check_doc", true);

          if (this.showAnnReg) {
            formData.set(
              `filling_date`,
              this.changeformatDatetoinsert(this.itemdata.filling_date)
            );
            formData.set(
              `receive_date`,
              this.changeformatDatetoinsert(this.itemdata.receive_date)
            );
            formData.set(
              `startdate`,
              this.changeformatDatetoinsert(this.itemdata.startdate)
            );
            formData.set(
              `enddate`,
              this.changeformatDatetoinsert(this.itemdata.enddate)
            );
            formData.set(
              `internaldate`,
              this.changeformatDatetoinsert(this.itemdata.internaldate)
            );
          } else {
            formData.set("filling_date", null);
            formData.set("receive_date", null);
            formData.set("startdate", null);
            formData.set(
              "enddate",
              this.changeformatDatetoinsert(this.itemdata.next_annuity_date) ||
              null
            );
            formData.set("internaldate", null);
          }
        } else {
          formData.append("dead_last_annuity_paid", "");
          formData.append("last_annuity_paid", "");
          formData.append("next_annuity_date", "");
          formData.append("final_due_date_for_next_payment", "");
          formData.append("check_doc", false);
        }

        if (this.showNew) {
          formData.append(
            "new_filling",
            this.changeformatDatetoinsert(this.itemdata.new_filling) || ""
          );

          formData.set("filling_date", null);
          formData.set("receive_date", null);
          formData.set("startdate", null);
          if (this.showNewFilingExact) {
            formData.set("newfilingECheck", true);
            formData.set("app_no", this.itemdata.app_no);
            formData.set(
              "date_of_application",
              this.changeformatDatetoinsert(
                this.itemdata.date_of_application
              ) || null
            );
            formData.set(
              "enddate",
              this.changeformatDatetoinsert(this.itemdata.enddate) || null
            );
          } else {
            formData.set("date_of_application", null);
            formData.set("newfilingECheck", false);
            formData.set("app_no", "");

            formData.set(
              "filling_date",
              this.changeformatDatetoinsert(this.itemdata.filling_date) || null
            );
            formData.set(
              "receive_date",
              this.changeformatDatetoinsert(this.itemdata.receive_date) || null
            );
            formData.set(
              "startdate",
              this.changeformatDatetoinsert(this.itemdata.startdate) || null
            );
          }
        } else {
          formData.set("newfilingECheck", false);
          formData.set("app_no", "");
          formData.set("date_of_application", null);
        }

        // if(this.doctype_actions_select.length > 0){
        //   const doclist_select = this.doctype_actions_select.join(", ");
        //   formData.append("documenttype_action_id", doclist_select);
        // }else{
        //   formData.append("documenttype_action_id", "");
        // }

        formData.append("documenttype_action_id", "");
        this.$showLoader();
        const resultAppointment = await api.AppointmentAddV2(formData);

        if (
          resultAppointment.status == 200 ||
          resultAppointment.status == 201
        ) {

          var dataadd_timeline = {

            timeline_status_id: Number(this.timelineStatus),
            case_id: resultAppointment.data.appointment_id,
            module_name: "Patent Docket",
            case_woker: Number(localStorage.getItem(server.USER_ID)),
            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
            status_note: this.status_note.trim(),
            visibility: this.visible_check,
          }
          const result_add = await api.creategetClientTimelineHistory(dataadd_timeline)
          try {
            const newCaseId = Number(resultAppointment.data.appointment_id);

            const caseDetailResult = await api.getgetTimelineDataDetail({
              params: { module_name: this.module_name, case_id: newCaseId },
            });
            const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

            const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
              params: { module_name: this.module_name, case_id: newCaseId },
            });
            const timelineData = visibilityResult.data || [];

            caseInfo.status = timelineData[0]?.status || '';
            caseInfo.lastUpdated = timelineData[0]?.status_time || '';

            const latestUpdate = {
              message: timelineData[0]?.status_note || '',
              date: timelineData[0]?.status_time || '',
            };

            await PDFCaseProgress.createToPDF(
              {
                caseInfo,
                latestUpdate,
                timelineData,
                caseId: newCaseId,
                moduleName: this.module_name,
              },
              { open: false }
            );
          } catch (pdfError) {
            console.error("PDF generation/upload failed:", pdfError);
            // Not re-thrown — the appointment/timeline entry was already created;
            // a PDF failure here shouldn't block the rest of saveItem (doctype
            // actions, soft files, change-master-record, transaction log, etc.
            // that follow).
          }

          if (this.doctype_actions_select.length > 0) {
            for (const [index, item] of this.doctype_actions_select.entries()) {
              var dataAdd = {
                documenttype_action_id: item,
                appointment_id: resultAppointment.data.appointment_id,
                appointment_type: `Patent`,
                documenttype_follow: 0,
              };
              await api.createAppointmentDoctypeActions(dataAdd);
            }
          }
          let formDataSoft = new FormData();

          if (this.uploadedFiles && typeof this.uploadedFiles === "object") {
            for (const [key, files] of Object.entries(this.uploadedFiles)) {
              if (Array.isArray(files)) {
                // เพิ่มไฟล์
                files.forEach((file) => {
                  formDataSoft.append("file", file);
                });
                // เก็บชื่อไฟล์คั่นด้วย ,
                const fileNames = files.map((file) => file.name).join(",");
                formDataSoft.append(key, fileNames);
              } else {
                formDataSoft.append("file", files);
                formDataSoft.append(key, files.name);
              }
            }
          }

          await api.createSotfFile(
            resultAppointment.data.appointment_id,
            formDataSoft
          );

          var dataaddchangeMasterRecord = this.changeMasterRecord;
          dataaddchangeMasterRecord.appointment_id =
            resultAppointment.data.appointment_id;
          dataaddchangeMasterRecord.create_by = Number(
            localStorage.getItem(server.USER_ID)
          );
          await api.createCHAGE_MASTER_RECORD(dataaddchangeMasterRecord);

          var dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "appointment",
            table_id: resultAppointment.data.appointment_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };

          await api.addTransectionLog(dataAdd);

          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );
          this.$hideLoader();

          if (mode == "paymentrequest") {
            var dataPush = {
              customer_name_master: dataset.cus_name,
              yourRef: "",
              ourRef: "",
              docketId: resultAppointment.data.appointment_id,
            };

            var custonerId = 0;
            custonerId = Number(dataset.cus_billing_id);
            const hasThai = /[\u0E00-\u0E7F]/;

            if (hasThai.test(dataset.cus_name)) {
              dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${dataset.client_ref}`;
              dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${dataset.file_no}`;
            } else {
              dataPush.yourRef = `Your Ref: ${dataset.client_ref}`;
              dataPush.ourRef = `Our Ref: ${dataset.file_no}`;
            }
            if (dataset.client_ref.trim() == "") {
              dataPush.yourRef = "";
            }
            this.$router.push({
              path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
              query: dataPush,
            });
            return;
          } else {
            this.$hideLoader();
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/appointment-patent-list"
            );
            return;
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
  watch: {
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    receive_date(val) {
      this.itemdata.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.itemdata.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.itemdata.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.itemdata.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.itemdata.internaldate = this.formatDate(this.internaldate);
    },
    new_filling(val) {
      this.itemdata.new_filling = this.formatDate(this.new_filling);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
  },
};
</script>

<style scoped>
.no-resize-textarea textarea {
  resize: none !important;
}

.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.heightsize90formadvance {
  height: 90px;
}

.heightsizesearch {
  height: 45%;
}

h3 {
  font-size: 1.17em;
}

.widthbtnnoticefile {
  width: 100%;
}

.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}

.bt-add {
  color: #1d88ac;
}

.mth {
  margin-top: -20px;
}
</style>
